import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientModule} from '@angular/common/http';
import {StoreModule} from '@ngrx/store';
import * as fromCountry from './+state/country.reducer';
import {EffectsModule} from '@ngrx/effects';
import {CountryEffects} from './+state/country.effects';
import {NGXLogger} from 'ngx-logger';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forFeature(
      fromCountry.COUNTRY_FEATURE_KEY,
      fromCountry.reducer
    ),
    EffectsModule.forFeature([CountryEffects]),
  ]
})
export class CountryStoreModule {

  constructor(private logger: NGXLogger) {
    logger.trace('*---------------------------------------------------------------------*');
    logger.trace('*', this.constructor.name, 'Loaded');
    logger.trace('*---------------------------------------------------------------------*');
  }

}
